import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model for data handling
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing a view for withdrawal requests.
 * @extends JetView
 */
export default class tableWithdrawalRequestView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current context
        const cur_user = this.getParam('user', true); // Fetching the current user ID from parameters
        const url = devConfig.geturlApi() + 'es/Client/GetClientWithdrawalRequests?PlayerId=' + cur_user + '&'; // API URL for fetching withdrawal requests

        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'datatable', // Webix datatable component
                            id: 'table', // ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling based on screen width
                            height: screen.width < 820 ? 405 : 0, // Conditional height based on screen width
                            columns: [
                                {
                                    id: 'detailTittle', // Column ID for detail title
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Detalles'), // Tooltip text for the column
                                    template: function(obj) { // Template function for rendering the column
                                        return '<span class=\'webix_icon wxi-close details\'></span>'; // Icon for details
                                    },
                                },
                                {
                                    id: 'ActionTittle', // Column ID for action title
                                    header: '', // Column header
                                    width: 70, // Column width
                                    height: 25, // Column height
                                    tooltip: 'Acción', // Tooltip text for the column
                                    template: function(obj) { // Template function for rendering the column
                                        if (
                                            obj.State == 'A' && // Check if the state is 'A'
                                            obj.AccountBank !== '' && // Ensure AccountBank is not empty
                                            obj.AccountBank !== undefined && // Ensure AccountBank is defined
                                            obj.AccountBank !== null // Ensure AccountBank is not null
                                        ) {
                                            if (
                                                devConfig.getPermAction(
                                                    'comissionsWithdrawalRequestsApprove', // Check permission for approving requests
                                                    'Approve',
                                                )
                                            ) {
                                                return '<span placeholder=\'Aprobar\' class=\'webix_icon wxi-close approve prm-comissionsWithdrawalRequestsApprove\'></span><span class=\'webix_icon wxi-close torefuse prm-comissionsWithdrawalRequestsApprove\'></span>'; // Approve and refuse icons
                                            } else {
                                                return ''; // No action if permission is not granted
                                            }
                                        } else {
                                            if (
                                                obj.State == 'P' && // Check if the state is 'P'
                                                obj.AccountBank !== '' && // Ensure AccountBank is not empty
                                                obj.AccountBank !== undefined && // Ensure AccountBank is defined
                                                obj.AccountBank !== null // Ensure AccountBank is not null
                                            ) {
                                                if (devConfig.getPermAction('comissionsWithdrawalRequestsPay', 'Pay')) {
                                                    return '<span placeholder=\'Pagar\' class=\'webix_icon wxi-close pay prm-comissionsWithdrawalRequestsPay\'></span><!--<span class=\'webix_icon wxi-close torefuse\'></span>-->'; // Pay icon
                                                } else {
                                                    return ''; // No action if permission is not granted
                                                }
                                            } else {
                                                return ''; // No action for other states
                                            }
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column ID for the request ID
                                    header: 'Id', // Column header
                                    width: 80, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ClientId', // Column ID for client ID
                                    header: _('ID Cliente'), // Column header with localization
                                    width: 90, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ClientName', // Column ID for client name
                                    header: _('Nombre Cliente'), // Column header with localization
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'VerifdniAnt', // Column ID for DNI verification
                                    header: _('DNI'), // Column header with localization
                                    width: 50, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Amount', // Column ID for amount
                                    header: _('Valor'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting for price
                                    exportType: 'number', // Export type for the column
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'State', // Column ID for state
                                    header: _('Estado'), // Column header with localization
                                    options: [ // Options for state dropdown
                                        { id: '', value: _('None') }, // None option
                                        { id: 'A', value: _('Activado') }, // Activated option
                                        { id: 'C', value: _('Cancelado') }, // Canceled option
                                        { id: 'I', value: _('Pagada') }, // Paid option
                                        { id: 'E', value: _('Eliminado') }, // Deleted option
                                        { id: 'P', value: _('Pendiente') }, // Pending option
                                        { id: 'R', value: _('Rechazado') }, // Rejected option
                                    ],
                                },
                                {
                                    id: 'CreatedLocal', // Column ID for creation date
                                    header: _('Fecha'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Department', // Column ID for department
                                    header: _('Departamento'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'City', // Column ID for city
                                    header: _('Ciudad'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'WayPay', // Column ID for payment method
                                    header: _('Forma de pago'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'AccountBank', // Column ID for bank account
                                    header: _('Cuenta Bancaria'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CodeInterbank', // Column ID for interbank code
                                    header: _('Código Interbancario'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Ip', // Column ID for IP address
                                    header: _('IP'), // Column header with localization
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: { // Event handlers for click events
                                details: function(euv, id) { // Handler for details click
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
                                },
                                pay: function(euv, id) { // Handler for pay click
                                    var vvthis = this; // Reference to the current context
                                    webix
                                        .modalbox({ // Display modal box for payment options
                                            title: _('Pregunta '), // Modal title
                                            buttons: [_('Pagar por Sistema'), _('Pagado fisicamente'), _('Cancelar')], // Modal buttons
                                            text: _('Elija la forma de pago'), // Modal text
                                            width: 500, // Modal width
                                        })
                                        .then(function(result) { // Handle modal result
                                            switch (result) {
                                                case '0': // Pay by system option
                                                    webix.confirm({ // Confirmation dialog
                                                        type: 'confirm-warning',
                                                        text:
                                                            _('Advertencia!') +
                                                            '<br/>' +
                                                            _('Desea Pagar Nota de Retiro?'), // Warning text
                                                        ok: _('Pagar Nota'), // Confirm button text
                                                        cancel: _('Salir'), // Cancel button text
                                                        callback: function(action) { // Callback for confirmation action
                                                            if (action === true) { // If confirmed
                                                                var item = vvthis.getItem(id); // Get the clicked item
                                                                webix
                                                                    .ajax() // AJAX request to pay withdrawal
                                                                    .headers({
                                                                        'Content-type': 'application/json', // Set content type
                                                                    })
                                                                    .post(
                                                                        devConfig.geturlApi() +
                                                                        'Client/PayWithdrawalRequestsAPI',
                                                                        '{ "Id":' + item.Id + '}', // Request body
                                                                        {
                                                                            error: function(
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                webix.message(_('Error! ')); // Error message
                                                                            },
                                                                            success: function(
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                item.State = 'I'; // Update item state to 'I'
                                                                                webix.message(
                                                                                    _('Envio de solicitud de pago. '), // Success message
                                                                                );
                                                                                vthis.$$('table').clearAll(); // Clear the table
                                                                                vthis.$$('table').load(url); // Reload the table data
                                                                            },
                                                                        },
                                                                    );
                                                            }
                                                        },
                                                    });
                                                    break;
                                                case '1': // Paid physically option
                                                    webix.confirm({ // Confirmation dialog
                                                        type: 'confirm-warning',
                                                        text:
                                                            _('Advertencia!') +
                                                            '<br/>' +
                                                            _('Desea Pagar Nota de Retiro?'), // Warning text
                                                        ok: _('Pagar Nota'), // Confirm button text
                                                        cancel: _('Salir'), // Cancel button text
                                                        callback: function(action) { // Callback for confirmation action
                                                            if (action === true) { // If confirmed
                                                                var item = vvthis.getItem(id); // Get the clicked item
                                                                webix
                                                                    .ajax() // AJAX request to pay withdrawal
                                                                    .headers({
                                                                        'Content-type': 'application/json', // Set content type
                                                                    })
                                                                    .post(
                                                                        devConfig.geturlApi() +
                                                                        'Client/PayWithdrawalRequests',
                                                                        '{ "Id":' + item.Id + '}', // Request body
                                                                        {
                                                                            error: function(
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                webix.message(_('Error! ')); // Error message
                                                                            },
                                                                            success: function(
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                item.State = 'I'; // Update item state to 'I'
                                                                                webix.message(
                                                                                    _('Nota de Retiro Pagada'), // Success message
                                                                                );
                                                                                vthis.$$('table').clearAll(); // Clear the table
                                                                                vthis.$$('table').load(url); // Reload the table data
                                                                            },
                                                                        },
                                                                    );
                                                            }
                                                        },
                                                    });
                                                    break;
                                                case '2': // Cancel option
                                                    break; // Do nothing
                                            }
                                        });
                                },
                                approve: function(euv, id) { // Handler for approve click
                                    var vvthis = this; // Reference to the current context
                                    webix.confirm({ // Confirmation dialog
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea Aprobar Nota de Retiro?'), // Warning text
                                        ok: _('Aprobar Nota'), // Confirm button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function(action) { // Callback for confirmation action
                                            if (action === true) { // If confirmed
                                                var item = vvthis.getItem(id); // Get the clicked item
                                                webix
                                                    .ajax() // AJAX request to approve withdrawal
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Client/AllowWithdrawalRequests',
                                                        '{ "Id":' + item.Id + '}', // Request body
                                                        {
                                                            error: function(text, data, XmlHttpRequest) {
                                                                webix.message(_('Error! ')); // Error message
                                                            },
                                                            success: function(text, data, XmlHttpRequest) {
                                                                item.State = 'P'; // Update item state to 'P'
                                                                webix.message(_('Nota de Retiro Aprobado')); // Success message
                                                                vthis.$$('table').clearAll(); // Clear the table
                                                                vthis.$$('table').load(url); // Reload the table data
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                                torefuse: function(euv, id) { // Handler for refuse click
                                    var vvthis = this; // Reference to the current context
                                    webix.confirm({ // Confirmation dialog
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea Rechazar Nota de Retiro?'), // Warning text
                                        ok: _('Rechazar Nota'), // Confirm button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function(action) { // Callback for confirmation action
                                            if (action === true) { // If confirmed
                                                var item = vvthis.getItem(id); // Get the clicked item
                                                webix
                                                    .ajax() // AJAX request to refuse withdrawal
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Client/CancelClientRequests',
                                                        '{ "Id":' + item.Id + '}', // Request body
                                                        {
                                                            error: function(text, data, XmlHttpRequest) {
                                                                webix.message(_('Error! ')); // Error message
                                                            },
                                                            success: function(text, data, XmlHttpRequest) {
                                                                item.State = 'E'; // Update item state to 'E'
                                                                webix.message(_('Nota de Retiro Rechazada')); // Success message
                                                                vthis.$$('table').clearAll(); // Clear the table
                                                                vthis.$$('table').load(url); // Reload the table data
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                            },
                            editable: true, // Enable editing of the datatable
                            tooltip: true, // Enable tooltips
                            math: true, // Enable mathematical operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // ID for the pager component
                            url: url, // Data source URL
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        /**
         * Retrieves the current user parameter from the application context.
         * @type {string}
         */
        const cur_user = this.getParam('user', true);

        /**
         * Initializes the grid variable with the table component.
         * @type {Object}
         */
        grid = $$('table');

        /**
         * Stores the URL for the grid data.
         * @type {string}
         */
        var url = grid.data.url;

        /**
         * Initializes the filter string for query parameters.
         * @type {string}
         */
        var filter = '';

        /**
         * Event listener for the 'bonusReport:filter' event.
         * @param {Object} filterData - The data used for filtering the grid.
         */
        this.on(this.app, 'bonusReport:filter', (filterData) => {
            /**
             * Converts filterData object into an array of entries.
             * @type {Array}
             */
            var object = Object.entries(filterData);

            /**
             * Initializes a string to build the query parameters.
             * @type {string}
             */
            var string1 = '';

            /**
             * Iterates through the filter data entries.
             */
            for (var i = 0; i < object.length; i++) {
                /**
                 * Checks if the entry value is not an object and not empty.
                 */
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    /**
                     * Handles the datepicker filter specifically.
                     */
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - ');
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        /**
                         * Appends other filter parameters to the string.
                         */
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                    }
                } else {
                    /**
                     * Handles object type filter values.
                     */
                    if (typeof object[i][1] === 'object') {
                        /**
                         * Converts the object into an array of entries.
                         * @type {Array}
                         */
                        var object2 = Object.entries(object[i][1]);

                        /**
                         * Iterates through the nested object entries.
                         */
                        for (var j = 0; j < object2.length; j++) {
                            /**
                             * Checks if the entry value is not null.
                             */
                            if (object2[j][1] !== null) {
                                /**
                                 * Handles the 'start' date filter.
                                 */
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'MinCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    /**
                                     * Handles the 'end' date filter.
                                     */
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'MaxCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            /**
             * Appends the current user ID to the filter string.
             */
            string1 = string1 + '&PlayerId=' + cur_user;

            /**
             * Clears the grid data before loading new data.
             */
            grid.clearAll();

            /**
             * Loads the grid with the constructed URL and filter parameters.
             */
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);

            /**
             * Updates the filter variable with the current filter string.
             */
            filter = string1;
        });

        /**
         * Event listener for sorting the grid after sorting is completed.
         * @param {string} by - The field by which the grid is sorted.
         * @param {string} dir - The direction of the sort (ascending/descending).
         * @param {boolean} as - Indicates if the sort is case-sensitive.
         */
        grid.attachEvent('onAfterSort', function(by, dir, as) {
            /**
             * Loads the grid with the sorted data.
             */
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir);
        });

        /**
         * Event listener for checking conditions before editing starts.
         * @param {string} id - The ID of the item being edited.
         */
        grid.attachEvent('onBeforeEditStart', function(id) {
            /**
             * Retrieves the item being edited.
             * @type {Object}
             */
            var item = this.getItem(id);
            console.log(item);

            /**
             * Checks the state of the item to determine if editing is allowed.
             */
            if (id.column == 'Action') {
                if (item.State == 'A') {
                } else if (item.State == 'P') {
                } else {
                    return false; // Prevents editing if the state is not allowed.
                }
                console.log(id);
            }
        });

        /**
         * Event listener for actions after editing stops.
         * @param {Object} state - The state of the edited cell.
         * @param {Object} editor - The editor instance.
         * @param {boolean} ignoreUpdate - Indicates if the update should be ignored.
         */
        grid.attachEvent('onAfterEditStop', function(state, editor, ignoreUpdate) {
            console.log(state);

            /**
             * Retrieves the item being edited.
             * @type {Object}
             */
            var item = this.getItem(editor.row);
            console.log(item);

            /**
             * Checks if the new value is different from the old value.
             */
            if (state.value != state.old) {
                /**
                 * Handles the case when the new value is 'A'.
                 */
                if (state.value == 'A') {
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/AllowWithdrawalRequests', '{ "Id":' + item.Id + '}', {
                            error: function(text, data, XmlHttpRequest) {
                                webix.message(_('Error! '));
                            },
                            success: function(text, data, XmlHttpRequest) {
                                item.State = 'P'; // Updates the state to 'P' after success.
                                webix.message('Cell value was changed');
                            },
                        });
                }

                /**
                 * Handles the case when the new value is 'P'.
                 */
                if (state.value == 'P') {
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/PayWithdrawalRequests', '{ "Id":' + item.Id + '}', {
                            error: function(text, data, XmlHttpRequest) {
                                webix.message(_('Error! '));
                            },
                            success: function(text, data, XmlHttpRequest) {
                                item.State = 'I'; // Updates the state to 'I' after success.
                                webix.message('Cell value was changed');
                            },
                        });
                }

                /**
                 * Handles the case when the new value is 'E'.
                 */
                if (state.value == 'E') {
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/CancelClientRequests', '{ "Id":' + item.Id + '}', {
                            error: function(text, data, XmlHttpRequest) {
                                webix.message(_('Error! '));
                            },
                            success: function(text, data, XmlHttpRequest) {
                                item.State = 'E'; // Updates the state to 'E' after success.
                                webix.message('Cell value was changed');
                            },
                        });
                }
            }
        });

        /**
         * Event listener for selecting a player.
         * @param {string} id - The ID of the selected player.
         */
        this.on(this.app, 'player:select', (id) => {
            /**
             * Loads the grid with data filtered by the selected player ID.
             */
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + id);
        }); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
